var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showSnackbar
        ? _c("Snackbar", {
            attrs: {
              snackbarColor: _vm.snackbarColor,
              snackbarMessage: _vm.snackbarMessage
            },
            on: {
              close: function($event) {
                return _vm.closeSnackbar()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content_box_for_tnc" },
        [
          _c(
            "v-card",
            { staticClass: "settings_panel_card", attrs: { flat: "" } },
            [
              _c(
                "v-toolbar",
                {
                  staticClass: "settings_toolbar",
                  attrs: { flat: "", dense: "" }
                },
                [
                  _c(
                    "v-toolbar-title",
                    { staticClass: "settings_panel_heading" },
                    [
                      _vm._v(
                        "Terms and Conditions ( " +
                          _vm._s(_vm.tncStatus ? "Default" : "Custom") +
                          " )"
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tnCPanel,
                          expression: "tnCPanel"
                        }
                      ]
                    },
                    [
                      _vm.isEditable && !_vm.disabletncChild
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "", depressed: "", small: "" },
                              on: { click: _vm.editConfiguration }
                            },
                            [_c("v-icon", [_vm._v("create")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isEditable
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function($event) {
                                  return _vm.saveEditedChanges(false)
                                }
                              }
                            },
                            [_c("v-icon", [_vm._v("check")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isEditable
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: { click: _vm.cancelEditedConfiguration }
                            },
                            [_c("v-icon", [_vm._v("clear")])],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.disabletncChild
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "#736B63",
                                dark: "",
                                small: "",
                                depressed: "",
                                id: "enableTNC"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveEditedChanges(true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Enable Tnc\n                    "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.disabletncChild
                        ? _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "#736B63",
                                dark: "",
                                small: "",
                                depressed: "",
                                id: "disableTNC"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveEditedChanges(true)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                        Disable TnC\n                    "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.tnCPanel,
                          expression: "!tnCPanel"
                        }
                      ],
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          _vm.tnCPanel = true
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("keyboard_arrow_down")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.tnCPanel
                ? _c(
                    "div",
                    { staticClass: "terms-and-conditions__section" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "ml-4 my-3 grey--text",
                              attrs: { xs1: "" }
                            },
                            [_c("b", [_vm._v("Number Of Days")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "ml-4 my-3", attrs: { xs10: "" } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedNum,
                                    expression: "selectedNum"
                                  }
                                ],
                                staticClass: "inputcallbackheader",
                                attrs: {
                                  type: "text",
                                  maxlength: "6",
                                  readonly: _vm.isEditable
                                },
                                domProps: { value: _vm.selectedNum },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.selectedNum = $event.target.value
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "ml-4 my-3 grey--text",
                              attrs: { xs1: "" }
                            },
                            [_c("b", [_vm._v("Terms & Conditions")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { staticClass: "ml-4 my-3", attrs: { xs8: "" } },
                            [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tnccontent,
                                    expression: "tnccontent"
                                  }
                                ],
                                staticClass:
                                  "certificateConfiguration inputcallbackheader",
                                attrs: { readonly: _vm.isEditable },
                                domProps: { value: _vm.tnccontent },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.tnccontent = $event.target.value
                                  }
                                }
                              })
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }